<template>
	<div class="experience-transportation">
		<div v-if="paylogicTransport">
			<div
				class="experience-transportation__block"
				v-for="(product, index) in paylogicInCart"
				:key="product.type.id"
			>
				<div
					class="experience-block__white-header"
					:class="{ 'experience-block__white-header--first': index === 0 }"
				>
					{{ product.numproducts }}x {{ getCountry(product) }}, {{ product.type.name.split('_')[1] }},
					{{ product.type.name.split('_')[2] }}
				</div>

				<div class="experience-transportation__content">
					<div class="experience-transportation__location-details">
						<span class="experience-transportation__country">{{ getCountry(product) }}</span>

						<span class="experience-transportation__city">{{ product.type.name.split('_')[1] }}</span>

						<span class="experience-transportation__pickup-location">
							{{ product.type.name.split('_')[2] }}
						</span>
					</div>

					<div class="experience-transportation__content-block">
						<div class="experience-transportation__block">
							<span class="experience-transportation__country">
								Arrival {{ shopConfig.festivalData.title }}
							</span>
							{{ product.type.name.split('_')[3] }}-{{ getYear }}*
						</div>

						<div class="experience-transportation__block">
							<span class="experience-transportation__country">
								From {{ shopConfig.festivalData.title }}
							</span>
							{{ product.type.name.split('_')[4] }}-{{ getYear }}*
						</div>
					</div>

					<!-- <div class="experience-transportation__disclaimer">
						<p>*excl. EU €5,- per order</p>
					</div> -->

					<div class="transportation-item__price-disclaimer">
						<p>{{ getDepartureInformationCopy(product) }}</p>
					</div>
				</div>
			</div>
		</div>

		<div v-if="partyTransport">
			<div
				class="experience-transportation__block"
				v-for="(product, index) in partyInCart"
				:key="product.type.id"
			>
				<div
					class="experience-block__white-header"
					:class="{ 'experience-block__white-header--first': index === 0 }"
				>
					{{ product.numproducts }}x {{ product.type.name }}
				</div>

				<div class="experience-transportation__content">
					<div class="experience-transportation__location-details">
						<span class="experience-transportation__country">
							{{ $t('experiencecontenttransportation.country') }}
						</span>

						<span class="experience-transportation__city">{{ product.type.meta.city }}</span>

						<span class="experience-transportation__pickup-location">{{ product.type.meta.location }}</span>
					</div>

					<div class="experience-transportation__content-block">
						<div class="experience-transportation__block">
							<span class="experience-transportation__country">
								To {{ shopConfig.festivalData.title }}
							</span>
							{{ product.type.meta.departureDateTime | dateWithTime }}
						</div>

						<div class="experience-transportation__block">
							<span class="experience-transportation__country">
								From {{ shopConfig.festivalData.title }}
							</span>
							{{ product.type.meta.returnDateTime | dateWithTime }}
						</div>
					</div>

					<div class="experience-transportation__disclaimer">* Estimated times</div>
				</div>
			</div>
		</div>

		<div>
			<div class="experience-transportation__button-container" v-if="!isShopUpdatePending">
				<Button class="experience-transportation__button button--small" :to="route"> {{ buttonLabel }} </Button>

				<Button class="experience-transportation__button button--small" @click.native="removeItems">
					{{ $t('page.shop.experience_builder.transportation.remove') }}
				</Button>
			</div>

			<div v-else>
				<Spinner />
			</div>
		</div>
	</div>
</template>

<script>
import countryList from '@/static/data/countryCodes.json';

export default {
	name: 'ExperienceContentTransportation',

	data() {
		return {
			countryList: countryList
		};
	},

	props: {
		products: Array,
		route: String,
		buttonLabel: String
	},

	computed: {
		getYear() {
			const date = new Date(this.shopConfig.festivalData.dateStart);
			return date.getFullYear();
		},
		hasPaylogicTransport() {
			/*
			 *   If the ID contains safety_group_event_travel then the bus provider is serverd via event travel
			 *   default the bussus are serverd form paylogic
			 *
			 * 	 chnanged to partybussen
			 */
			return this.transportData.length && !this.transportData[0].id.includes('partybussen');
		},

		transportData() {
			return (
				this.$store.getters['shopapi/getProducts'] && this.$store.getters['shopapi/getProducts'].transportation
			);
		},

		partyTransport() {
			return this.transportData.filter(
				item => item.id.includes('partybussen') || item.id.includes('partybussen')
			);
		},

		paylogicTransport() {
			return this.transportData.filter(item => !item.id.includes('partybussen'));
		},

		partyInCart() {
			return this.removeOrderFeeFromData.filter(item => item.type.id.includes('partybussen'));
		},

		paylogicInCart() {
			return this.removeOrderFeeFromData.filter(item => !item.type.id.includes('partybussen'));
		},

		removeOrderFeeFromData() {
			return (this.products && this.products.filter(item => item.type.slug != 'orderfee')) || [];
			// return this.products;
		},

		shopConfig() {
			return this.$store.getters['shopconfig/getData'];
		},

		shopCart() {
			return this.$store.getters['shopconfig/getCart'];
		},

		isShopUpdatePending() {
			return this.$store.getters['shopapi/getIsShopUpdatePending'];
		}
	},

	methods: {
		getDepartureInformationCopy(item) {
			if (this.getCountry(item).toLowerCase() === 'nederland') {
				return '*We will communicate your exact departure time 2 days before departure.';
			}

			return '*We will communicate your exact departure time 5 days before departure.';
		},

		getCountry(item) {
			return this.countryList.find(country => country.value === item.type.name.split('_')[0].toLowerCase()).type;
		},

		removeItems() {
			this.$fireErrorEventWithPromis(6001).then(response => {
				this.$store.dispatch('shopapi/removeOptionFromExperienceBuilder', this.products);
			});
		}
	}
};
</script>

<style lang="scss">
$component: 'experience-transportation';

.#{$component} {
	&__includes {
		margin-bottom: calc($global-spacing / 2);

		font-size: 16px;
		text-transform: uppercase;
	}

	&__content {
		padding: 0 $global-spacing;
		margin-bottom: $global-spacing;

		font-size: 14px;
	}

	&__button-container {
		display: flex;
		justify-content: space-around;

		padding: calc($global-spacing / 2) $global-spacing $global-spacing;
	}

	&__location-details {
		overflow: hidden;
	}

	&__country {
		display: block;
		font-family: $font-bold;
		font-size: 14px;
		text-transform: uppercase;
	}

	&__city {
		position: relative;
		display: block;
		font-family: $font-bold;
		font-size: 24px;
		line-height: 30px;
		text-transform: uppercase;

		width: 100%;

		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	&__pickup-location {
		display: block;
		font-size: 14px;
		height: 50px;
	}

	&__content-block {
		display: flex;
		justify-content: space-between;

		padding-bottom: 25px;
	}

	&__people {
		display: block;
	}

	&__disclaimer {
		padding-top: 20px;

		font-family: $font-regular-italic;
		font-size: 14px;
	}

	&__button {
		max-width: 200px;
	}
}
</style>
